import React from "react";
import { TablePagination, TablePaginationProps } from "@material-ui/core";
import MaterialTable, { MaterialTableProps } from "material-table";
import i18n from "./i18n";

// material table with some defaults
const DefaultTable = <T extends object>({ options, ...props }: MaterialTableProps<T>) => (
    <MaterialTable
        {...props}
        localization={i18n.localization}
        options={{
            actionsColumnIndex: -1,
            draggable: false,
            emptyRowsWhenPaging: false,
            pageSize: 10,
            pageSizeOptions: [10, 25, 50],
            ...options,
        }}
        components={{
            Pagination: PatchedPagination,
        }}
    />
);

function PatchedPagination(props: TablePaginationProps) {
    const {
        ActionsComponent,
        onChangePage,
        onChangeRowsPerPage,
        ...tablePaginationProps
    } = props;

    return (
        <TablePagination
            {...tablePaginationProps}
            // @ts-expect-error onChangePage was renamed to onPageChange
            onPageChange={onChangePage}
            onRowsPerPageChange={onChangeRowsPerPage}
            ActionsComponent={(subprops) => {
                const { onPageChange, ...actionsComponentProps } = subprops;
                return (
                    // @ts-expect-error ActionsComponent is provided by material-table
                    <ActionsComponent
                        {...actionsComponentProps}
                        onChangePage={onPageChange}
                    />
                );
            }}
        />
    );
}

export default DefaultTable;
